"use client";

export const getIsPwa = () =>
  !!window?.matchMedia("(display-mode: standalone)").matches;
